import React from 'react';
import PropTypes from 'prop-types';

import * as styles from './PostsList.module.scss';

const propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string,
      heading: PropTypes.string,
      date: PropTypes.string,
      datetime: PropTypes.string
    })
  )
};

const PostItem = ({ href, date, datetime, heading }) => {
  return <div className={styles.rootItem}>
    {date && <span className={styles.rootDate}>
      <time dateTime={datetime}>{date}</time>
    </span>}
    {heading && <h2 className={styles.rootHeading}>
      <a className={styles.rootLink} href={href}>{heading}</a>
    </h2>}
  </div>;
};

const PostsList = ({
  items
}) => {
  if (!items) {
    return false;
  }

  return <div className={styles.root}>
    {items.map((args, index) => <PostItem {...args} key={index} />
    )}
  </div>;
};

PostsList.propTypes = propTypes;

export default PostsList;
